<template>
  <div class="search-result-container">
    <img class="logo" :src="info.parseFailedWebResult.searchFrom === 'baidu' ? require('./baidu.png') : require('./google.png')" alt="">
    <router-link
      target="_blank"
      :to="{ name: 'news-detail-view', params: { rowKey: info.rowKey } }"
    >
      <div class="title" v-html="highLightkeyword(info.title)"></div>
    </router-link>
    <div class="content-box">
      <img v-if="imgSrc" class="search-img" :src="imgSrc" alt="">
      <div class="info">
        <div :class="[imgSrc ? 'content' : 'content line2']" v-html="highLightkeyword(this.content)"></div>
        <div class="detail-row">
          <div class="box">
            <span class="detail">{{ info.parseFailedWebResult.source }}</span>
            <span style="margin-left: 15px" class="detail time">{{ info.parseFailedWebResult.publishTimeClean }}</span>
          </div>
          <div class="detail">
            <a target="_blank" :href="info.parseFailedWebResult.url">原文链接</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => ({
        title: '',
        parseFailedWebResult: {
          content: '',
          publishTime: '',
          source: '',
          url: ''
        }
      })
    },
    keyword: {
      type: String,
      default: '军事'
    }
  },

  computed: {
    imgSrc() {
      if(this.info.parseFailedWebResult.filesInfo){
        let arr = JSON.parse(this.info.parseFailedWebResult.filesInfo)
        return arr[0].img || arr[0].unknown
      } else {
        return  undefined
      }
    },
    content() {
      if(this.info.parseFailedWebResult.contentList){
        let arr = JSON.parse(this.info.parseFailedWebResult.contentList)
        return arr[0].p
      } else {
        return  undefined
      }
    }
  },
  methods: {
    highLightkeyword(text) {
      let reg = new RegExp(this.keyword, 'gim')
      if(text) {
        return text.replace(reg, `<span class='search-high-light-red'>${this.keyword}</span>`)
      } else {
        return ""
      }
    }
  }
}
</script>

<style lang="less" scoped>
.search-result-container {
  width: 1000px;
  position: relative;
  padding: 25px 0 0 25px;
  text-align: justify;
  transition: background 0.2s;

  .title {
    font-size: 20px;
    color: #435ACF;
    font-weight: 500;
    margin-bottom: 10px;
  }
  .content-box{
    display: flex;
  }

  .search-img{
    width: 140px;
    height: 90px;
    margin-right: 10px;
    border-radius: 4px;
  }

  .info{
    flex:  1;
  }
  .content {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    line-height: 25px;
    letter-spacing: 1px;
    color: #333333;
    font-weight: 500;
    position: relative;
    top: -6px
  }
  .line2{
    -webkit-line-clamp: 2;
  }


  .detail-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #999999;

    .time {
      color: #bbb;
      font-size: 16px;
    }
    .detail {
      overflow: hidden;
      flex: 2;
      font-size: 14px;
      text-align: left;

      &:last-child {
        text-align: right;
      }

      &:nth-child(2) {
        flex: 1;
      }
    }

    a {
      text-decoration: underline;
      color: #bbb
    }
  }
  .logo{
    width: 26px;
    height: 26px;
    position: absolute;
    left: -15px;
    top: 30px
  }
}
</style>
